import { Base } from '@studiometa/js-toolkit';

/**
 * Quantity Input Class
 */
export default class UpsellProduct extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'UpsellProduct',
    refs: [
      'quantityInput',
      'upsellAddToCart',
      'quantitySelector',
      'minus',
      'plus',
      'btn',
      'quantityContainer',
      'price',
      'salePrice',
      'datalayer',
      'link',
    ],
    emits: ['add'],
  };

  /**
   *
   */
  mounted() {
    this.defaultStringPrice = this.$refs.price.innerHTML;
    this.defaultNumberPrice = Number.parseFloat(
      this.$refs.price.innerHTML.replace(',', '.'),
    ).toFixed(2);
    if (this.$refs.salePrice) {
      this.defaultSalePrice = Number.parseFloat(this.$refs.salePrice.innerHTML);
    }
  }

  /**
   *
   */
  onPlusClick() {
    this.stepUp();
  }

  /**
   *
   */
  onMinusClick() {
    this.stepDown();
  }

  /**
   *
   */
  stepUp() {
    this.$refs.quantityInput.stepUp();
    this.$refs.quantitySelector.innerHTML = this.$refs.quantityInput.value;
    this.$refs.quantityInput.setAttribute('value', this.quantity);
    if (this.quantity === 1) {
      this.$refs.btn.classList.add('hidden');
      this.$refs.quantityContainer.classList.remove('hidden');
    }
    this.updatePrices();
    this.$emit('add');
  }

  /**
   *
   */
  stepDown() {
    this.$refs.quantityInput.stepDown();
    this.$refs.quantityInput.setAttribute('value', this.quantity);

    if (this.quantity === 0) {
      this.$refs.quantityContainer.classList.add('hidden');
      this.$refs.btn.classList.remove('hidden');
    }
    this.$refs.quantitySelector.innerHTML = this.$refs.quantityInput.value;
    this.updatePrices();
    this.$emit('add');
  }

  /**
   *
   */
  updatePrices() {
    if (this.$refs.salePrice) {
      this.$refs.salePrice.innerHTML = this.totalSalePrice.replace('.', ',');
    }

    this.$refs.price.innerHTML = this.totalPrice.replace('.', ',');
  }

  /**
   * Click on Btn
   */
  onBtnClick() {
    this.stepUp();
  }

  /**
   * Navigate to the obfuscated link URL
   */
  navigateToLink() {
    const encoded = this.$refs.link?.dataset.href;
    if (encoded) {
      window.location.href = atob(encoded);
    }
  }

  /**
   * Click on obfuscated link
   */
  onLinkClick() {
    this.navigateToLink();
  }

  /**
   * Keyboard activation on obfuscated link
   * @param {KeyboardEvent} event
   */
  onLinkKeydown({ event }) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.navigateToLink();
    }
  }

  /**
   * Get parsed Quantity value
   * @returns {number}
   */
  get quantity() {
    return Number.parseInt(this.$refs.quantityInput.value);
  }

  /**
   * Get hidden inputs
   * @returns {string}
   */
  get inputsContent() {
    return this.$refs.upsellAddToCart.innerHTML;
  }

  /**
   * Get Total default product price
   * @returns {number}
   */
  get totalPrice() {
    return this.quantity === 0
      ? this.defaultNumberPrice
      : (this.defaultNumberPrice * this.quantity).toFixed(2);
  }

  /**
   * Get Sale Price
   * @returns {number}
   */
  get totalSalePrice() {
    return this.quantity === 0
      ? this.defaultSalePrice
      : (this.defaultSalePrice * this.quantity).toFixed(2);
  }

  /**
   * @returns {object} datalayer of items
   */
  get datalayer() {
    return {
      item_id: this.$refs.datalayer.dataset.id,
      item_name: this.$refs.datalayer.dataset.title,
      affiliation: this.$refs.datalayer.dataset.affiliation,
      discount:
        this.$refs.datalayer.dataset.discount <= 0
          ? undefined
          : this.$refs.datalayer.dataset.discount,
      coupon: undefined,
      index: this.$refs.datalayer.dataset.index,
      item_brand: this.$refs.datalayer.dataset.affiliation,
      item_category: this.$refs.datalayer.dataset.category,
      item_variant: undefined,
      location_id: undefined,
      price: this.$refs.datalayer.dataset.price,
      quantity: this.quantity,
    };
  }
}
